(function () {
    'use strict';

    angular
        .module('app.core')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
           {
               state: 'login',
               config: {
                   url: '/login',
                   templateUrl: 'app/login/login.html?v=' + opsIncludeVersion,
                   controller: 'LoginController',
                   controllerAs: 'vm',
                   title: 'Login',
                   settings: {
                       nav: 100,
                       content: '<i class="fa fa-sign-in"></i> <span class="leftNavText">Login</span>',
                       authMode: 0
                   }
               }
           },
              {
                  state: 'logout',
                  config: {
                      url: '/logout',
                      templateUrl: 'app/login/logout.html?v=' + opsIncludeVersion,
                      controller: 'LogoutController',
                      controllerAs: 'vm',
                      title: 'Logout',
                      settings: {
                          nav: 0,
                          content: '<i class="fa fa-sign-out"></i> Logout {{vm.count}}',
                          authMode: 1

                      }
                  }
           },
              {
                  state: 'resetpassword',
                  config: {
                      url: '/resetpassword/{uid}',
                      templateUrl: 'app/login/resetpassword.html?v=' + opsIncludeVersion,
                      controller: 'ResetPasswordController',
                      controllerAs: 'vm',
                      title: 'Reset Password',
                      settings: {
                          authMode: 0
                      }
                  }
            }
        ];
    }
})();
